var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import topPagesSrc1 from '@images/marketing/FAQ-Subscription.jpg';
import topPagesSrc2 from '@images/marketing/Home-Map.jpg';
import blogPostSrc2 from '@images/marketing/Home-MoreThanMeals.jpg';
import blogPostSrc1 from '@images/marketing/Home-WhyNomNom.jpg';
import { MealName, ProbioticName, TreatName, productInfo } from '@marketing/content';
var treats = productInfo.treats, meals = productInfo.meals, probiotics = productInfo.probiotics;
var Beef = MealName.Beef, Chicken = MealName.Chicken, Lamb = MealName.Lamb, Pork = MealName.Pork, Turkey = MealName.Turkey, TurkeyChicken = MealName.TurkeyChicken, SamplerPack = MealName.SamplerPack;
var FullSpectrum = ProbioticName.FullSpectrum, GITargeted = ProbioticName.GITargeted;
var ChickenJerky = TreatName.ChickenJerky, BeefJerky = TreatName.BeefJerky, BeefBlueberry = TreatName.BeefBlueberry, ChickenCranberry = TreatName.ChickenCranberry, SweetPotato = TreatName.SweetPotato;
var chickenJerky = treats[ChickenJerky];
var fullSpectrum = probiotics[FullSpectrum];
var beefMash = meals[Beef];
var chickenCuisine = meals[Chicken];
var porkPotluck = meals[Pork];
var turkeyFare = meals[Turkey];
var lambPilaf = meals[Lamb];
var turkeyChickenCookout = meals[TurkeyChicken];
var samplerPack = meals[SamplerPack];
var beefJerky = treats[BeefJerky];
var beefBlueberry = treats[BeefBlueberry];
var chickenCranberry = treats[ChickenCranberry];
var sweetPotato = treats[SweetPotato];
var giTargeted = probiotics[GITargeted];
export default {
    menus: {
        explorePlans: {
            howItWorksRoute: '/how-it-works',
            findInStoreRoute: '/retail',
            topPages: [
                {
                    title: 'How it works',
                    imgSrc: topPagesSrc1,
                    url: '/how-it-works',
                },
                {
                    title: 'Find in store',
                    imgSrc: topPagesSrc2,
                    url: '/retail',
                },
            ],
        },
        learnMore: {
            faqLibraryRoute: '/faq',
            blogRoute: '/learn',
            contactRoute: 'https://support.nomnomnow.com/hc/en-us/requests/new',
            helpRoute: 'https://support.nomnomnow.com/hc/en-us',
            blogPosts: [
                {
                    title: 'Indoor Activities for Dogs',
                    imgSrc: blogPostSrc1,
                    description: "Here's how to know if your dog is experiencing separation anxiety.",
                    url: '/',
                },
                {
                    title: 'Outdoor Activities for Dogs',
                    imgSrc: blogPostSrc2,
                    description: "Here's a list of fun things to do outside with your pup.",
                    url: '/',
                },
            ],
        },
        otherProducts: {
            treats: {
                mobile: [beefJerky, chickenJerky, beefBlueberry, chickenCranberry, sweetPotato],
                desktop: [
                    beefJerky,
                    chickenJerky,
                    __assign(__assign({}, beefBlueberry), { maxWidth: '143px' }),
                    __assign(__assign({}, chickenCranberry), { maxWidth: '159px' }),
                    sweetPotato,
                ],
            },
            probiotics: [fullSpectrum, giTargeted],
            topSellers: [beefJerky, sweetPotato, fullSpectrum],
        },
        ourMeals: {
            meals: {
                desktop: [
                    turkeyFare,
                    beefMash,
                    chickenCuisine,
                    porkPotluck,
                    __assign(__assign({}, turkeyChickenCookout), { maxWidth: '134px' }),
                    lambPilaf,
                    samplerPack,
                ],
                mobile: [
                    lambPilaf,
                    turkeyChickenCookout,
                    beefMash,
                    chickenCuisine,
                    turkeyFare,
                    porkPotluck,
                    samplerPack,
                ],
            },
            topSellers: [chickenCuisine, beefMash, lambPilaf, turkeyFare],
        },
    },
};
